module.exports = __webpack_public_path__ + "static/tinkoff-65846d146861d7de6cefa63ac7656378.svg";